import { toast } from "react-toastify";
import {
  USER_TOKEN,
  TOKEN_EXPIRY_DATE,
  MSG,
  PERSONALITY_ID,
  USER_ID,
  INVITED_ITINERARY_ID,
  INVITED_USER_ID,
  IS_INVITED_USER_TRAVEL_QUIZ_COMPLETED,
  GUEST_ROUTE_PUBLIC_ID,
  EMAIL_FOR_SEND_VERFICATION_MAIL,
} from "../constants";
import { ROUTES } from "../constants/routes";
import { clearUserDetails } from "../../state/user/actions";
import html2pdf from "html2pdf.js";
import { store } from "../../state/store";
import { imagesArray } from "../mockData/unsplashImages";
import { allRoutes } from "../mockData/allroutes";
import {
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
} from "../../assets/images/unpaidItinerary";
import { generateError, Success } from "../../services/useCommonSerivce";
import apiClient from "../../network/restAPI";
import { CHECK_FB_EMAIL } from "../../network/restAPI/apiRoutes";

const unpaidItineraryImages = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
];
const desktopImages = [
  "d1",
  "d2",
  "d3",
  "d4",
  "d5",
  "d6",
  "d7",
  "d8",
  "d9",
  "d10",
  "d11",
  "d12",
  "d13",
  "d14",
  "d15",
  "d16",
  "d17",
  "d18",
];
const mobileImages = [
  "m1",
  "m2",
  "m3",
  "m4",
  "m5",
  "m6",
  "m7",
  "m8",
  "m9",
  "m10",
  "m11",
  "m12",
  "m13",
  "m14",
  "m15",
  "m16",
  "m17",
  "m18",
];

export const containsSpecialChars = (str) => {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return specialChars.test(str);
};

export const isContainOneLetter = (str) => {
  const regex = /[a-zA-Z]/;
  return regex.test(str);
};

export const isContainOneNumber = (str) => {
  const regex = /\d/;
  return regex.test(str);
};

export const isUserLoggedIn = () => {
  return !!localStorage.getItem(USER_TOKEN);
};

export const emailValidation = (value) => {
  let errorMessage;
  if (!value) {
    errorMessage = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    errorMessage = "Invalid email address";
  }
  return errorMessage;
};

export const setAccessTokenAndExpiry = (token, isExpiryStore) => {
  const next30Days = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
  localStorage.setItem(USER_TOKEN, token);
  localStorage.setItem(TOKEN_EXPIRY_DATE, isExpiryStore ? next30Days : "");
};

export const showLogoutToast = () => {
  toast.success(MSG.ON_LOGOUT_SUCCESS);
};

let generatedImagesForDesktop = [];
let generatedImagesForMobile = [];

export const getRandomImage = (isMobileView, isInitialCall) => {
  if (isInitialCall) {
    generatedImagesForMobile = [];
    generatedImagesForDesktop = [];
  }
  const randomValue = Math.floor(Math.random() * 18);
  if (isMobileView) {
    if (generatedImagesForMobile.length > 10) {
      generatedImagesForMobile = [];
    }
    if (generatedImagesForMobile.includes(randomValue)) {
      return getRandomImage(isMobileView);
    } else {
      generatedImagesForMobile.push(randomValue);
    }
  } else {
    if (generatedImagesForDesktop.length > 10) {
      generatedImagesForDesktop = [];
    }
    if (generatedImagesForDesktop.includes(randomValue)) {
      return getRandomImage(isMobileView);
    } else {
      generatedImagesForDesktop.push(randomValue);
    }
  }
  if (isMobileView) {
    return `${process.env.REACT_APP_CDN_URL}mobile/${mobileImages[randomValue]}.png`;
  }
  return `${process.env.REACT_APP_CDN_URL}desktop/${desktopImages[randomValue]}.png`;
};

export const handleScroll = (id) => {
  const element = document.querySelector(`#${id}`);
  setTimeout(() => {
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, 10);
};

export const setExpiryToken = () => {
  const next30Days = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
  const expiresIn = next30Days.getTime();
  localStorage.setItem(TOKEN_EXPIRY_DATE, expiresIn);
};

export const isTokenExpired = () => {
  const currentTime = new Date().getTime();
  const expiredTime = localStorage.getItem(TOKEN_EXPIRY_DATE);

  if (expiredTime) {
    if (currentTime >= expiredTime) {
      return true;
    }
    return false;
  } else {
    return false;
  }
};

export const isUserExist = (navigate) => {
  const token = localStorage.getItem(USER_TOKEN);
  if (token && typeof navigate === "function") {
    navigate(ROUTES.home);
    return true;
  }
  return false;
};

export const logout = (navigate, dispatch) => {
  navigate(ROUTES?.login);
  localStorage.clear();
  sessionStorage.clear();
  dispatch(clearUserDetails());
};

export const getFileExtensionOfImage = (filename) => {
  const fileExtensions = filename.split(".");
  return fileExtensions.length > 1 ? "." + fileExtensions.pop() : "";
};

export const storePersonalityId = (id) => {
  sessionStorage.setItem(PERSONALITY_ID, id);
};

export const getPersonalityId = () => {
  return sessionStorage.getItem(PERSONALITY_ID);
};

export const removePersonalityId = () => {
  sessionStorage.removeItem(PERSONALITY_ID);
};

export const getUserId = () => {
  return localStorage.getItem(USER_ID);
};

export const getEmailForSendVerificationMail = () => {
  return localStorage.getItem(EMAIL_FOR_SEND_VERFICATION_MAIL);
};

export const setEmailForSendVerificationMail = (email) => {
  localStorage.setItem(EMAIL_FOR_SEND_VERFICATION_MAIL, email);
};

export const formatDateToMonthYear = (createdAt) => {
  const date = new Date(createdAt);
  const options = { year: "numeric", month: "long" };
  const formattedDate = date.toLocaleDateString(undefined, options);
  return formattedDate;
};
export const convertToBase64 = (imgUrl) => {
  return new Promise((resolve, reject) => {
    if (imgUrl) {
      fetch(imgUrl)
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            reject(new Error("Failed to fetch the image"));
          }
        })
        .then((imageBlob) => {
          const reader = new FileReader();
          reader.readAsDataURL(imageBlob);
          reader.onloadend = () => {
            resolve(reader.result);
          };
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      return null;
    }
  });
};

const logoEtho =
  "data:image/png;base64,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";

export const downloadPdf = async () => {
  var element = document.getElementById("pdf-content");
  var opt = {
    margin: [0.75, 0.2, 0.2, 0.2],
    filename: "itinerary.pdf",
    image: { type: "jpeg", quality: 0.98 },
    pagebreak: {
      mode: ["avoid-all", "css", "legacy"],
    },
    html2canvas: { scale: 2, dpi: 96, y: 0, x: 0, scrollY: 0, scrollX: 0 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  // New Promise-based usage:
  html2pdf()
    .from(element)
    .set(opt)
    .toPdf()
    .get("pdf")
    .then(function (pdf) {
      var totalPages = pdf.internal.getNumberOfPages();
      for (var i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(150);
        pdf.addImage(logoEtho, "PNG", 3.4, 0.3, 1.47, 0.3);
        pdf.text(
          "Ethoventures Itinerary - Page " + i + " of " + totalPages,
          pdf.internal.pageSize.getWidth() - 3,
          pdf.internal.pageSize.getHeight() - 0.2
        );
      }
    })
    .save();
};

export const useSetInvitedUserParams = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const invitedItineraryId = urlParams.get("id");
  const invitedUserId = urlParams.get("userId");
  return { invitedItineraryId, invitedUserId };
};

export const getInvitedUserId = () => {
  return localStorage.getItem(INVITED_USER_ID);
};

export const getItineraryId = () => {
  return localStorage.getItem(INVITED_ITINERARY_ID);
};

export const setIsInvitedUserTravelQuizCompleted = (value) => {
  localStorage.setItem(IS_INVITED_USER_TRAVEL_QUIZ_COMPLETED, value);
};

export const getIsInvitedUserTravelQuizCompleted = () => {
  return localStorage.getItem(IS_INVITED_USER_TRAVEL_QUIZ_COMPLETED);
};

export const setGuestRoutePublicId = (value) => {
  if (value) {
    localStorage.setItem(GUEST_ROUTE_PUBLIC_ID, value);
    return;
  }
  localStorage.removeItem(GUEST_ROUTE_PUBLIC_ID);
};

export const getGuestRoutePublicId = () => {
  return localStorage.getItem(GUEST_ROUTE_PUBLIC_ID);
};

export const removeInvitedUserDetails = () => {
  localStorage.removeItem(INVITED_USER_ID);
  localStorage.removeItem(INVITED_ITINERARY_ID);
  localStorage.removeItem(IS_INVITED_USER_TRAVEL_QUIZ_COMPLETED);
};

export const getCode = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = urlParams.get("code");
  return code;
};

export const setInvitedUserDetails = (invitedItineraryId, invitedUserId) => {
  if (invitedItineraryId && invitedUserId) {
    localStorage.setItem(INVITED_ITINERARY_ID, invitedItineraryId);
    localStorage.setItem(INVITED_USER_ID, invitedUserId);
  }
};

export const appendQueryParametersInImage = (url, q = 40) => {
  if (!url) {
    return "";
  }
  const hasQuery = url?.includes("?");
  const separator = hasQuery ? "&" : "?";
  return `${url}${separator}w=2500&q=${q}&utm_source=Ethoventures&utm_medium=referral`;
};

export const reduceImageQuality = (url, w = 350, q = 60, h) => {
  const hasQuery = url.includes("?");
  const separator = hasQuery ? "&" : "?";
  return `${url}${separator}w=${w}&q=${q}&h=${h}&utm_source=Ethoventures&utm_medium=referral`;
};

export const roundToNearestValue = (x) => Math.round(x / 100) * 100;

export const handleRedirectionToQuizPage = (navigate) => {
  let personalityId = "";
  if (getUserId()) {
    const data = store?.getState()?.user;
    personalityId =
      getPersonalityId() || data?.userDetails?.personalityType?._id;
  } else {
    personalityId = getPersonalityId();
  }
  if (personalityId) {
    if (getInvitedUserId()) {
      return navigate(ROUTES?.travelQuiz);
    }
    return navigate(ROUTES?.travelStyle);
  }
  return navigate(ROUTES?.personality);
};

export const showQuizCtaInHeader = (location) => {
  let isShowQuizCta = true;
  if (
    [
      ROUTES.travelStyle,
      ROUTES.travelInvite,
      ROUTES.travelSelect,
      ROUTES?.travelBudget,
      ROUTES?.travelDays,
      ROUTES?.whySignup,
      ROUTES?.travelQuiz,
      ROUTES?.travelLocation,
      ROUTES?.personalityTest,
      ROUTES?.personalitySuccess,
      ROUTES?.personality,
    ].includes(location?.pathname)
  ) {
    isShowQuizCta = false;
  }

  return isShowQuizCta;
};

export const getInProgressImages = () => {
  let arr = [...imagesArray];
  return arr[Math.floor(Math.random() * arr.length)];
};

export const getUnpaidItineraryImages = () => {
  let arr = [...unpaidItineraryImages];
  return arr[Math.floor(Math.random() * arr.length)];
};

export const getAnOrA = (str) => {
  const vowels = ["a", "e", "i", "o", "u"];
  const firstChar = str[0].toLowerCase();
  return vowels.includes(firstChar) ? "An " : "A ";
};

export const extractInitialsFromMate = (mate) => {
  const { firstName, lastName } = mate;
  const firstInitial = firstName ? firstName[0].toUpperCase() : "";
  const lastInitial = lastName ? lastName[0].toUpperCase() : "";
  return `${firstInitial}${lastInitial}`;
};

export const capitalizeFirstLetter = (word) => {
  if (word?.length === 0) {
    return "";
  }
  return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
};

export const checkNotFoundPage = (pathname) => {
  const allROutes = [...allRoutes];
  let isNotFoundPage = false;
  if (pathname) {
    if (!allROutes.includes(pathname)) {
      isNotFoundPage = true;
    }
    return isNotFoundPage;
  }
  return false;
};

export const isCheckAllItineraryGenerated = (item) => {
  const isAllGenerated =
    item?.itinerary?.itinerary?.length === item?.metaData[0]?.number_of_days &&
    item?.itinerary?.itinerary[0]?.trip_advisor_suggestions?.length > 0;
  return isAllGenerated;
};

export const formatTripadvisorData = (data) => {
  const modifyData = Array?.isArray(data) && data?.length > 0 ? data : [];
  const order = ["accommodation", "restaurants", "activities"];
  if (modifyData?.length) {
    modifyData.sort((a, b) => {
      return order.indexOf(a.category) - order.indexOf(b.category);
    });
  }
  return modifyData;
};

export const decodeFacebookToken = async (token) => {
  return new Promise(async (resolve) => {
    try {
      const response = await fetch(
        `https://graph.facebook.com/v13.0/me?fields=id,name,email&access_token=${token}`
      );

      if (response.ok) {
        const data = await response.json();
        resolve(Success(data));
      } else {
        resolve({ error: "Failed to fetch user data" });
      }
    } catch (error) {
      resolve({ error: error.message });
    }
  });
};

export const checkFbLoginEmail = async (fbId) => {
  return new Promise(async (resolve) => {
    try {
      const { data } = await apiClient.get(CHECK_FB_EMAIL(fbId));
      // console.log("checkFbLoginEmail", data);
      resolve(Success(data));
    } catch (error) {
      // console.log("checkFbLoginEmail", error);
      resolve(generateError(error));
    }
  });
};
